import { useQuery } from '@tanstack/react-query';
import { fetchDealerSageMappings } from '../services/dealerSageMappings';
import { dealerKeys } from './useDealersQuery';

export function useDealerSageMappingsQuery(dealerId: string) {
    return useQuery({
        queryKey: dealerKeys.sageMappings(dealerId),
        queryFn: () => fetchDealerSageMappings(dealerId),
        enabled: !!dealerId,
        staleTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
    });
}
